import { ClientReferenceUploadMessage, IconGroup } from '../Types/Notifications.types';
import { AppDispatch } from '../../app/store';
import { fetchNotificationsByJobid, fetchNotificationsByUser, setNewNotification } from '../Slices/Notifications.slice';
import { Messages } from '../../Constants/Messages';
import { handleGetStatusDetail } from '../../component/status-widget/statusWidget.slice';
import { Guid } from 'guid-typescript';

export function addClientRulesetSuccessNotification(
    clientReferenceUploadMessage: ClientReferenceUploadMessage,
    dispatch: AppDispatch,
) {
    dispatch(handleGetStatusDetail(Guid.parse(clientReferenceUploadMessage.groupId)));
    dispatch(fetchNotificationsByJobid(clientReferenceUploadMessage.groupId));
    dispatch(setNewNotification());
}

export function addClientRulesetFailureNotification(
    clientReferenceUploadMessage: ClientReferenceUploadMessage,
    dispatch: AppDispatch,
) {
    dispatch(handleGetStatusDetail(Guid.parse(clientReferenceUploadMessage.groupId)));
    dispatch(fetchNotificationsByJobid(clientReferenceUploadMessage.groupId));
    dispatch(setNewNotification());
}

export function addUserClientRulesetSuccessNotification(
    clientReferenceUploadMessage: ClientReferenceUploadMessage,
    dispatch: AppDispatch,
) {
    dispatch(fetchNotificationsByUser());
    dispatch(setNewNotification());
}

export function addUserClientRulesetFailureNotification(
    clientReferenceUploadMessage: ClientReferenceUploadMessage,
    dispatch: AppDispatch,
) {
    dispatch(fetchNotificationsByUser());
    dispatch(setNewNotification());
}